import React, { useEffect } from "react";
import { useAuth } from "@workos-inc/authkit-react";
import { useNavigate } from "react-router-dom";
import SiteLoader from "../../components/site-loader/SiteLoader";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";

export default function Callback() {
  const { user, isLoading, signOut } = useAuth();
  const navigate = useNavigate();
  const { value: isMyDashboardFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.MY_DASHBOARD,
    false,
  );

  const reDirectURL = () => {
    return isMyDashboardFeatureEnabled ? "/my-dashboard" : "/";
  };

  useEffect(() => {
    if (!isLoading) {
      if (user) {
        const storedPath = localStorage.getItem("authRedirectPath");
        const intendedPath =
          storedPath && storedPath.startsWith("/") ? storedPath : null;

        localStorage.removeItem("authRedirectPath");

        navigate(intendedPath || reDirectURL(), { replace: true });
      } else {
        console.error("❌ [Callback] Authentication failed in callback");
        signOut();
      }
    }
  }, [user, isLoading, navigate, signOut]);

  return (
    // this part is not really visible. I'm keeping it for now, just in case.
    <div>
      <div>
        <SiteLoader />
        <h2>Processing authentication...</h2>
        <p>Restoring your session...</p>
      </div>
    </div>
  );
}
